import Vuex from 'vuex';
import Vue from 'vue';
import ChannelGetter from '@/store/getters/channel-getter';
import QuestionnaireMutation from '@/store/mutations/questionnaire-mutation';
import {FooterInfo} from '@/static/footer';
import CommonActions from '@/store/actions/common-action';
import CourseActions from './actions/course-action';

Vue.use(Vuex);

export interface GlobalState {
  questionFlagText?: string; //表单中flag文本内容
  phone: string;
  /**课程信息库数据*/
  courseList: Array<{ name: string; id: number; }>;
  /**老师信息库数据*/
  teacherList: Array<{ name: string; id: number; }>;
  /**门店信息库数据*/
  storeList: Array<{ name: string; id: number; }>;
  /**教师信息库数据*/
  semesterList: Array<{ name: string; id: number }>;
}


export default new Vuex.Store({
  state: {
    phone: FooterInfo.phone,  //手机号码
    courseList: [], //课程下拉框
    teacherList: [], //教师下拉列表
    storeList: [],
    semesterList: []
  },
  mutations: {
    ...QuestionnaireMutation,
  },
  actions: {
    ...CommonActions,
    ...CourseActions
  },
  modules: {},
  getters: {
    ...ChannelGetter,
  },
});
